// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__+M2G5","left":"Virtual_left__YR2My","wrapper":"Virtual_wrapper__s8bVw"};